import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Youtube } from 'lucide-react';

import logoImg from '@/assets/logo.png';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const cols = [
    { 
      title: "Company", 
      links: [
        { name: "About us", href: "/about" },
        { name: "Careers", href: "mailto:careers@memads.in" },
        { name: "Blog", href: "/blog" },
        { name: "Press", href: "mailto:press@memads.in" }
      ] 
    },
    { 
      title: "Support", 
      links: [
        { name: "Help Center", href: "/help" },
        { name: "Safety Tips", href: "/safety" },
        { name: "Contact us", href: "/contact" },
        { name: "Sitemap", href: "/sitemap" }
      ] 
    },
    { 
      title: "Legal", 
      links: [
        { name: "Terms of Service", href: "/terms" },
        { name: "Privacy Policy", href: "/privacy" },
        { name: "Cookie Policy", href: "/cookies" },
        { name: "Contact Legal", href: "mailto:legal@memads.in" }
      ] 
    },
    { 
      title: "For Business", 
      links: [
        { name: "Post an Ad", href: "/post" },
        { name: "Browse Listings", href: "/listings" },
        { name: "My Listings", href: "/my-listings" },
        { name: "Contact us", href: "/contact" }
      ] 
    },
  ];

  return (
    <footer className="border-t border-border bg-foreground text-background mt-16">
      <div className="mx-auto max-w-7xl px-4 py-12 md:py-16">
        <div className="grid gap-8 md:grid-cols-5">
          {/* Brand Col */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-flex items-center justify-center bg-white px-6 py-4 rounded-2xl h-28 w-auto shadow-sm hover:brightness-95 transition">
              <img src={logoImg} alt="MemAds Logo" className="h-20 w-auto object-contain" />
            </Link>
            <p className="mt-3 text-sm text-background/70 leading-relaxed">
              India's modern marketplace for buyers and sellers. Find anything, sell everything.
            </p>
            <div className="mt-4 flex gap-2">
              {[Facebook, Instagram, Twitter, Youtube].map((Icon, i) => (
                <a key={i} href="#" aria-label="Social link" className="grid h-9 w-9 place-items-center rounded-lg bg-background/10 transition hover:bg-primary text-background hover:text-primary-foreground">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Link Cols */}
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-heading text-sm font-semibold">{c.title}</h4>
              <ul className="mt-3 space-y-2 text-sm text-background/70">
                {c.links.map((link) => (
                  <li key={link.name}>
                    {link.href.startsWith('/') ? (
                      <Link to={link.href} className="hover:text-background transition">
                        {link.name}
                      </Link>
                    ) : (
                      <a href={link.href} className="hover:text-background transition">
                        {link.name}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background/10 pt-6 text-xs text-background/60 md:flex-row">
          <p>© {currentYear} MemAds. All rights reserved.</p>
          <p>Made with care in India.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
